import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	OnChanges,
} from "@angular/core";

@Component({
	selector: "app-index-text",
	templateUrl: "./index-text.directive.html",
	styleUrls: ["./index-text.directive.css"],
	encapsulation: ViewEncapsulation.None,
})
export class IndexTextDirective implements OnInit, OnChanges {
	@Input() strIndex: String;
	@Input() strText: String;
	@Input() fontSize: String;
	@Input() indexColor?: String;
	@Input() textColor?: String;
	@Input() borderStyle?: String;
	@Input() borderRadius?: String;
	@Input() marginStyle?: String;
	@Input() backgroundStyle?: String;
	@Input() paddingStyle?: String;

	constructor() {}

	ngOnInit() {}
	ngOnChanges(changes) {}
}
